/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from './initialState';
var sampleLoadingTablesSetActive = produce(function (draft, action) {
  draft.meta.activeSltId = action.payload.id;
}, initialState);
export default sampleLoadingTablesSetActive;